import _ from 'lodash';
import {
  SAVE_PROGRAM_SUCCESS,
  DELETE_PROGRAM_SUCCESS,
  APPLY_FILTERS,
  SAVE_APPLICATION_SUCCESS,
  JOIN_WAITLIST_SUCCESS,
  DELETE_APPLICATION_SUCCESS,
  GET_SCHOOLS_ERROR,
  SCHOOL_HOVER,
  REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR,
  GET_ADDED_APPLICATION_PROGRAM,
  SYNC_ADDED_PROGRAM_SAVED_PROGRAM,
} from '../constants';
import {
  ADD_SCHOOLS,
  SCHOOLS_API_REQUEST,
  SCHOOLS_API_SUCCESS,
  SCHOOLS_API_FAILURE,
  ADD_SCHOOL,
  SCHOOL_API_REQUEST,
  SCHOOL_API_SUCCESS,
  SCHOOL_API_FAILURE,
  ADD_SCHOOLS_PROGRAMS,
  SCHOOLS_PROGRAMS_API_REQUEST,
  SCHOOLS_PROGRAMS_API_SUCCESS,
  SCHOOLS_PROGRAMS_API_FAILURE,
  ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE,
  ADD_SAVED_PROGRAM_AUTOCOMPLETE,
  CLEAR_SAVED_PROGRAM_AUTOCOMPLETE,
  REQUEST_SAVED_PROGRAM_AUTOCOMPLETE,
  SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE,
  FAILURE_SAVED_PROGRAM_AUTOCOMPLETE,
  ADD_SCHOOLS_AUTOCOMPLETE,
  REQUEST_SCHOOLS_AUTOCOMPLETE,
  SUCCESS_SCHOOLS_AUTOCOMPLETE,
  FAILURE_SCHOOLS_AUTOCOMPLETE,
  ADD_ACCEPTED_OFFERS,
  ADD_ACCEPTED_OFFERS_SUCCESS,
  ADD_ACCEPTED_OFFERS_FAILURE,
  ADD_DECLINED_OFFERS,
  ADD_DECLINED_OFFERS_SUCCESS,
  ADD_DECLINED_OFFERS_FAILURE,
  ADD_OPT_OUT_OFFERS,
  ADD_OPT_OUT_OFFERS_SUCCESS,
  ADD_OPT_OUT_OFFERS_FAILURE,
  ADD_NO_RESPONSE_OFFERS,
  ADD_NO_RESPONSE_OFFERS_SUCCESS,
  ADD_NO_RESPONSE_OFFERS_FAILURE,
  ADD_PENDING_WAITLIST_OFFERS,
  ADD_PENDING_WAITLIST_OFFERS_SUCCESS,
  ADD_PENDING_WAITLIST_OFFERS_FAILURE,
  UPDATE_WAITLIST_OFFERS,
  UPDATE_WAITLIST_OFFERS_SUCCESS,
  UPDATE_WAITLIST_OFFERS_FAILURE,
  ADD_PENDING_WAITLIST_PROGRAMS,
  ADD_PENDING_WAITLIST_PROGRAMS_SUCCESS,
  ADD_PENDING_WAITLIST_PROGRAMS_FAILURE,
  WAITLIST_SUBMISSIONS_STATE,
  WAITLIST_SUBMISSIONS_STATE_SUCCESS,
  WAITLIST_SUBMISSIONS_STATE_FAILURE,
  GET_SR_ADDITIONAL_QUESTIONS_SUCCESS,
} from '../actions/actionTypes';
import analytics from '../services/analytics';

const initialState = {
  loaded: false,
  loading: false,
  schools: [],
  zonedSchoolLoginRequiredText: '',
  normalSchools: {
    result: [],
  },
  normalWaitlistSchools: {
    result: [],
  },
  pendingWaitlistOffers: [],
  pendingWaitlistPrograms: [],
  acceptedAndDeclinedOffers: [],
  canAddRemoveWaitlist: null,
  canEditWaitlistOfferResponse: null,
  showWaitlistPriorityGroupAndPosition: null,
  srAdditionalQuestions: [],
  parameters: [],
  error: null,
  optionsDict: {},
  autocomplete: {
    savedProgramSchoolsUnapplied: {
      autocompleteList: ['', ''],
    },
    savedPrograms: [],
    autocompleteSchools: [],
  },
  latestSchoolsRequestId: 0,
};

const handlePageLoadForAnalytics = (state, queryParams) => {
  const { normalSchools } = state;
  let analyticSchools = [];
  normalSchools.result.forEach(school_id => {
    let school = normalSchools.entities.school[school_id].school;
    analyticSchools.push(school.dbn);
  });
  if(analyticSchools.length > 0){
    analytics({
      eventLabel: 'schoolDirectoryPageLoad',
      dataDictionary: {
        pageUrl: window.location.href,
        queryParams: queryParams,
        schoolDbns: analyticSchools.join(),
        loggedIn: true
      },
    });
  }
}

const sync_saved_program_application_program = (application, state, queryParams) => {
  state.schools.map((school) => {
    if (school.programs.entities.program){
      Object.values(school.programs.entities.program).map((program) => {
        let saved_program_idx = state.studentAppData[application].savedPrograms.findIndex(
          s => s.directory_program_id === program.id
        )
        let application_program_idx = state.studentAppData[application].applicationPrograms.findIndex(
          s => s.directory_program_id === program.id
        )
        if(application_program_idx > -1){
          program.savedApplication = true;
          program.savedApplicationId = state.studentAppData[application].applicationPrograms[application_program_idx].id;
        } else {
          program.savedApplication = false;
          program.savedApplicationId = null;
        }
        if(saved_program_idx > -1){
          program.saved = true;
          program.savedProgramId = program.saved_program_id = state.studentAppData[application].savedPrograms[saved_program_idx].id;
        } else {
          program.saved = false;
          program.savedProgramId = program.saved_program_id = null;
        }
      })
    }
  });

  handlePageLoadForAnalytics(state, queryParams);

}

export default function schools(state = initialState, action) {
  switch (action.type) {
    case ADD_SCHOOLS: {
      // eslint-disable-next-line no-shadow
      const { schools, normal, count, switches, zonedSchoolLoginRequiredText, requestId } = action.payload;
      if (requestId !== state.latestSchoolsRequestId) {
        return state; // stale - a newer getSchools() call has since started
      }
      return {
        ...state,
        loaded: true,
        loading: false,
        schools: [...state.schools, ...schools],
        normalSchools: normal,
        count,
        switches,
        zonedSchoolLoginRequiredText,
      };
    }
    case SAVE_PROGRAM_SUCCESS: {
      const { id, applicationId, schoolId, respData } = action.payload;
      const schoolIndex = state.schools.findIndex(s => s.id === schoolId);
      let newSchools;
      if (schoolIndex > -1) {
        const school = { ...state.schools[schoolIndex] };
        school.programs.entities.program[id].saved = true;
        school.programs.entities.program[id].savedProgramId = respData.id.toString();
        // use slice to keep order
        newSchools = [...state.schools.slice(0, schoolIndex), school, ...state.schools.slice(schoolIndex + 1)];
        if(state.studentAppData){
          state.studentAppData[applicationId].savedPrograms.push(
            {
              'directory_program_id': id,
              'id': respData.id
            }
          )
        }
      }

      return {
        ...state,
        schools: newSchools || [...state.schools],
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [schoolId]: {
                ...state.normalSchools.entities.school[schoolId],
                programs: {
                  ...state.normalSchools.entities.school[schoolId].programs,
                  entities: {
                    ...state.normalSchools.entities.school[schoolId].programs.entities,
                    program: {
                      ...state.normalSchools.entities.school[schoolId].programs.entities.program,
                      [id]: {
                        ...state.normalSchools.entities.school[schoolId].programs.entities.program[id],
                        saved: true,
                        savedProgramId: respData.id.toString(),
                      },
                    },
                  },
                },
              },
            },
          },
        },
        result: [...state.normalSchools.result, id],
      };
    }
    case DELETE_PROGRAM_SUCCESS: {
      const { id, application, schoolId } = action.payload;
      const schoolIndex = state.schools.findIndex(s => s.id === schoolId);
      let newSchools;
      if (schoolIndex > -1) {
        const school = { ...state.schools[schoolIndex] };
        school.programs.entities.program[id].saved = false;
        school.programs.entities.program[id].savedProgramId = null;
        // use slice to keep order
        newSchools = [...state.schools.slice(0, schoolIndex), school, ...state.schools.slice(schoolIndex + 1)];
        if(state.studentAppData){
          let saved_p_idx = state.studentAppData[application].savedPrograms.findIndex(sp => sp.directory_program_id === id);
          if(saved_p_idx > -1){
            state.studentAppData[application].savedPrograms.splice(saved_p_idx, 1);
          }
        }
      }

      return {
        ...state,
        schools: newSchools || [...state.schools],
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [schoolId]: {
                ...state.normalSchools.entities.school[schoolId],
                programs: {
                  ...state.normalSchools.entities.school[schoolId].programs,
                  entities: {
                    ...state.normalSchools.entities.school[schoolId].programs.entities,
                    program: {
                      ...state.normalSchools.entities.school[schoolId].programs.entities.program,
                      [id]: {
                        ...state.normalSchools.entities.school[schoolId].programs.entities.program[id],
                        saved: false,
                        savedProgramId: null,
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    case SAVE_APPLICATION_SUCCESS: {
      const { id, schoolId, respData, applicationId } = action.payload;
      const schoolIndex = state.schools.findIndex(s => s.id === schoolId);
      let newSchools;
      if (schoolIndex > -1) {
        const school = { ...state.schools[schoolIndex] };
        if(school.programs.entities.program[id]){
          school.programs.entities.program[id].savedApplication = true;
          school.programs.entities.program[id].savedApplicationId = respData.id.toString();
        } else {
          school.programs.entities.program[id] = respData.directory_program_data;
          school.programs.entities.program[id].savedApplication = true;
          school.programs.entities.program[id].savedApplicationId = respData.id.toString();
        }
        // use slice to keep order
        newSchools = [...state.schools.slice(0, schoolIndex), school, ...state.schools.slice(schoolIndex + 1)];
        if(state.studentAppData){
          state.studentAppData[applicationId].applicationPrograms.push(
            {
              'directory_program_id': id,
              'id': respData.id
            }
          )
        }
      }

      return {
        ...state,
        schools: newSchools || [...state.schools],
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [schoolId]: {
                ...state.normalSchools.entities.school[schoolId],
                programs: {
                  ...state.normalSchools.entities.school[schoolId].programs,
                  entities: {
                    ...state.normalSchools.entities.school[schoolId].programs.entities,
                    program: {
                      ...state.normalSchools.entities.school[schoolId].programs.entities.program,
                      [id]: {
                        ...state.normalSchools.entities.school[schoolId].programs.entities.program[id],
                        savedApplication: true,
                        savedApplicationId: respData.id.toString(),
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }
    case DELETE_APPLICATION_SUCCESS: {
      const deletedId = action.payload.id;
      const applicationId = action.payload.applicationId;
      const deletedSchoolId = action.payload.schoolId;
      let deletedSchoolIndex = -1;
      if(state.schools.length > 0){
        deletedSchoolIndex = state.schools.findIndex(s => s.id === deletedSchoolId);
      }
      let deletedNewSchools = [];
      if (deletedSchoolIndex > -1) {  
        const deletedSchool = { ...state.schools[deletedSchoolIndex] };
        if(deletedSchool.programs.entities.program[deletedId]){
          deletedSchool.programs.entities.program[deletedId].savedApplication = false;
          deletedSchool.programs.entities.program[deletedId].savedApplicationId = null;
        }
        // use slice to keep order
        deletedNewSchools = [...state.schools.slice(0, deletedSchoolIndex), deletedSchool, ...state.schools.slice(deletedSchoolIndex + 1)];
        if(state.studentAppData){
          let saved_p_idx = state.studentAppData[applicationId].applicationPrograms.findIndex(sp => sp.directory_program_id === deletedId);
          if(saved_p_idx > -1){
            state.studentAppData[applicationId].applicationPrograms.splice(saved_p_idx, 1);
          }
        }
      }

        return {
          ...state,
          schools: deletedNewSchools || [...state.schools],
          normalSchools: {
            ...state.normalSchools,
            ...(state.normalSchools.entities.school && {
              entities: {
                school: {
                  ...state.normalSchools.entities.school,
                  ...(state.normalSchools.entities.school[deletedSchoolId] && {
                    [deletedSchoolId]: {                    
                      ...state.normalSchools.entities.school[deletedSchoolId],
                      ...(state.normalSchools.entities.school[deletedSchoolId].programs && {
                        programs: {
                          ...state.normalSchools.entities.school[deletedSchoolId].programs,
                          ...(state.normalSchools.entities.school[deletedSchoolId].programs.entities && {
                            entities: {
                              ...state.normalSchools.entities.school[deletedSchoolId].programs.entities,
                              ...(state.normalSchools.entities.school[deletedSchoolId].programs.entities.program && {
                                program: {
                                  ...state.normalSchools.entities.school[deletedSchoolId].programs.entities.program,
                                  [deletedId]: {
                                    ...state.normalSchools.entities.school[deletedSchoolId].programs.entities.program[deletedId],
                                    savedApplication: false,
                                    savedApplicationId: null,
                                  },
                                },
                              }),
                            },
                          }),                        
                        },
                      })
                    },
                  }),
                  
                },
              },
            })            
          },
        };      
    }

    case JOIN_WAITLIST_SUCCESS: {
      const { id, schoolId, respData } = action.payload;
      const schoolIndex = state.schools.findIndex(s => s.id === schoolId);
      let newSchools;
      if (schoolIndex > -1) {
        const school = { ...state.schools[schoolIndex] };
        school.programs.entities.program[id].joinedWaitlist = true;
        school.programs.entities.program[id].waitlistProgramId = respData.id.toString();
        // use slice to keep order
        newSchools = [...state.schools.slice(0, schoolIndex), school, ...state.schools.slice(schoolIndex + 1)];
      }

      return {
        ...state,
        schools: newSchools || [...state.schools],
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [schoolId]: {
                ...state.normalSchools.entities.school[schoolId],
                programs: {
                  ...state.normalSchools.entities.school[schoolId].programs,
                  entities: {
                    ...state.normalSchools.entities.school[schoolId].programs.entities,
                    program: {
                      ...state.normalSchools.entities.school[schoolId].programs.entities.program,
                      [id]: {
                        ...state.normalSchools.entities.school[schoolId].programs.entities.program[id],
                        joinedWaitlist: true,
                        waitlistProgramId: respData.id.toString(),
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }

    case REMOVE_WAITLIST_SUCCESS_SCHOOL_DIR: {
      const { id, schoolId, waitlistId } = action.payload;
      const schoolIndex = state.schools.findIndex(s => s.id === schoolId);
      let newSchools;
      if (schoolIndex > -1) {
        const school = { ...state.schools[schoolIndex] };
        school.programs.entities.program[id].joinedWaitlist = false;
        school.programs.entities.program[id].waitlistProgramId = waitlistId.toString();
        // use slice to keep order
        newSchools = [...state.schools.slice(0, schoolIndex), school, ...state.schools.slice(schoolIndex + 1)];
      }

      return {
        ...state,
        schools: newSchools || [...state.schools],
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [schoolId]: {
                ...state.normalSchools.entities.school[schoolId],
                programs: {
                  ...state.normalSchools.entities.school[schoolId].programs,
                  entities: {
                    ...state.normalSchools.entities.school[schoolId].programs.entities,
                    program: {
                      ...state.normalSchools.entities.school[schoolId].programs.entities.program,
                      [id]: {
                        ...state.normalSchools.entities.school[schoolId].programs.entities.program[id],
                        joinedWaitlist: false,
                        waitlistProgramId: waitlistId.toString(),
                      },
                    },
                  },
                },
              },
            },
          },
        },
      };
    }

    case ADD_PENDING_WAITLIST_OFFERS:
      return {
        ...state,
        pendingWaitlistOffers: action.payload,
      };

    case ADD_PENDING_WAITLIST_PROGRAMS:
      return {
        ...state,
        pendingWaitlistPrograms: action.payload,
      };

    case ADD_ACCEPTED_OFFERS:
    case ADD_DECLINED_OFFERS:
    case ADD_OPT_OUT_OFFERS:
    case ADD_NO_RESPONSE_OFFERS:
      return {
        ...state,
        acceptedAndDeclinedOffers: [...action.payload, ...state.acceptedAndDeclinedOffers],
      };

    case UPDATE_WAITLIST_OFFERS: {
      const { waitlistId, offerResponse } = action.payload;
      const { pendingWaitlistOffers, acceptedAndDeclinedOffers } = state;
      let newOffer = null;
      newOffer = pendingWaitlistOffers.find(offer => offer.id === waitlistId);
      if(newOffer){
        newOffer = { ...newOffer, offer_response: offerResponse };
      }
      let newPendingWaitlistOffers = pendingWaitlistOffers.filter(offer => offer.id !== waitlistId);
      let newAcceptedAndDeclinedOffers = [...acceptedAndDeclinedOffers];
      if (offerResponse === 'AC') {
        newAcceptedAndDeclinedOffers.forEach(offer => {
          if (offer.offer_response === 'AC') {
            offer.offer_response = 'DE'
          }
          return offer;
        })
        if(newOffer){
          newAcceptedAndDeclinedOffers = [newOffer, ...newAcceptedAndDeclinedOffers];
        }
        newPendingWaitlistOffers.forEach(offer => {
          if (offer.is_main_offer && !offer.is_shs_discovery_offer) {
            offer.offer_response = 'DE'
            newAcceptedAndDeclinedOffers = [offer, ...newAcceptedAndDeclinedOffers];
          }
        });
      } else {
        let newDeclinedOffer = null;
        if(!newOffer){
          newDeclinedOffer = acceptedAndDeclinedOffers.find(offer => offer.id === waitlistId);
        }
        if(newOffer){
          newAcceptedAndDeclinedOffers = [...acceptedAndDeclinedOffers, newOffer];
        } else if(newDeclinedOffer){
          newAcceptedAndDeclinedOffers.forEach(offer => {
            if (offer.offer_response == 'AC' && !offer.is_shs_discovery_offer && offer.id == waitlistId) {
              offer.offer_response = 'DE'
              return offer;
            }
          });
        }
        let oneMainRoundOffer = newPendingWaitlistOffers.filter((offer) => offer.offer_response === 'PE' && offer.is_main_offer)
        if (oneMainRoundOffer.length == 1 && newOffer.is_main_offer){
          oneMainRoundOffer.forEach(offer => {
            if (offer.is_main_offer && !offer.is_shs_discovery_offer) {
              offer.offer_response = 'AC';
              newAcceptedAndDeclinedOffers = [offer, ...newAcceptedAndDeclinedOffers];
            }
          });
        }
      }
      newPendingWaitlistOffers = newPendingWaitlistOffers.filter((offer) => offer.offer_response === 'PE');

      return {
        ...state,
        acceptedAndDeclinedOffers: newAcceptedAndDeclinedOffers,
        pendingWaitlistOffers: newPendingWaitlistOffers,
      };
    }

    case WAITLIST_SUBMISSIONS_STATE: {
      const { can_add_remove_waitlist, can_edit_waitlist_offer_response, show_waitlist_priority_group_and_position, can_add_programs_to_waitlist, show_favorite_programs_section } = action.payload;
      return {
        ...state,
        canAddRemoveWaitlist: can_add_remove_waitlist,
        canEditWaitlistOfferResponse: can_edit_waitlist_offer_response,
        showWaitlistPriorityGroupAndPosition: show_waitlist_priority_group_and_position,
        canAddProgramToWaitlist: can_add_programs_to_waitlist,
        showFavoriteProgramsSection : show_favorite_programs_section
      };
    }

    case ADD_PENDING_WAITLIST_OFFERS_SUCCESS:
    case ADD_ACCEPTED_OFFERS_SUCCESS:
    case ADD_DECLINED_OFFERS_SUCCESS:
    case ADD_OPT_OUT_OFFERS_SUCCESS:
    case ADD_NO_RESPONSE_OFFERS_SUCCESS:
    case UPDATE_WAITLIST_OFFERS_SUCCESS:
    case ADD_PENDING_WAITLIST_PROGRAMS_SUCCESS:
    case WAITLIST_SUBMISSIONS_STATE_SUCCESS:
      return {
        ...state,
        loaded: true,
        loading: false,
      };

    case ADD_PENDING_WAITLIST_OFFERS_FAILURE:
    case ADD_ACCEPTED_OFFERS_FAILURE:
    case ADD_DECLINED_OFFERS_FAILURE:
    case ADD_OPT_OUT_OFFERS_FAILURE:
    case ADD_NO_RESPONSE_OFFERS_FAILURE:
    case UPDATE_WAITLIST_OFFERS_FAILURE:
    case ADD_PENDING_WAITLIST_PROGRAMS_FAILURE:
    case WAITLIST_SUBMISSIONS_STATE_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case GET_SCHOOLS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }

    case SCHOOL_HOVER: {
      const id = action.payload;
      return {
        ...state,
        normalSchools: {
          ...state.normalSchools,
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              [id]: {
                ...state.normalSchools.entities.school[id],
                scrolled: !state.normalSchools.entities.school[id].scrolled,
              },
            },
          },
        },
      };
    }

    case APPLY_FILTERS: {
      return {
        ...state,
        optionsDict: {
          ...state.optionsDict,
          ...action.payload.optionsDict,
        },
      };
    }
    case SCHOOLS_API_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        latestSchoolsRequestId: (state.latestSchoolsRequestId || 0) + 1,
      };
    case SCHOOLS_API_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case SCHOOLS_API_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case ADD_SCHOOLS_PROGRAMS: {
      // eslint-disable-next-line no-shadow
      const { schools, normal } = action.payload;
      return {
        ...state,
        loaded: true,
        loading: false,
        schools: [...state.schools, ...schools],
        normalSchools: normal,
      };
    }
    case SCHOOLS_PROGRAMS_API_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case SCHOOLS_PROGRAMS_API_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case SCHOOLS_PROGRAMS_API_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }

    case ADD_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE: {
      // eslint-disable-next-line no-shadow
      const autocompleteList = action.payload;
      const schoolId = action.payload.school_id;
      return {
        ...state,
        autocomplete: {
          ...state.autocomplete,
          savedProgramSchoolsUnapplied: autocompleteList,
          savedProgramSchoolsUnappliedIds: schoolId,
        },
      };
    }
    case REQUEST_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case SUCCESS_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case FAILURE_SAVEDPROGRAM_SCHOOL_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case ADD_SAVED_PROGRAM_AUTOCOMPLETE: {
      // eslint-disable-next-line no-shadow
      const { savedPrograms } = action.payload;
      return {
        ...state,
        autocomplete: {
          ...state.autocomplete,
          savedPrograms,
        },
      };
    }
    case CLEAR_SAVED_PROGRAM_AUTOCOMPLETE: {
      return {
        ...state,
        autocomplete: {
          ...state.autocomplete,
          savedPrograms: [],
        },
      };
    }
    case REQUEST_SAVED_PROGRAM_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case SUCCESS_SAVED_PROGRAM_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case FAILURE_SAVED_PROGRAM_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case ADD_SCHOOLS_AUTOCOMPLETE: {
      // eslint-disable-next-line no-shadow
      const { autocompleteSchools, autocompleteSchoolsId, autocompleteSchoolsDbn } = action.payload;
      return {
        ...state,
        autocomplete: {
          ...state.autocomplete,
          autocompleteSchools,
          autocompleteSchoolsId,
          autocompleteSchoolsDbn,
        },
      };
    }
    case REQUEST_SCHOOLS_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case SUCCESS_SCHOOLS_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case FAILURE_SCHOOLS_AUTOCOMPLETE: {
      return {
        ...state,
      };
    }
    case ADD_SCHOOL: {
      const { school, normal } = action.payload;
      const normalSchool = normal.entities.school;
      return {
        ...state,
        schools: [...state.schools, ...school],
        normalSchools: {
          result: _.uniq([...state.normalSchools.result, normal.result]),
          entities: {
            school: {
              ...state.normalSchools.entities.school,
              ...normalSchool,
            },
          },
        },
      };
    }
    case SCHOOL_API_REQUEST:
      return {
        ...state,
      };
    case SCHOOL_API_SUCCESS:
      return {
        ...state,
      };
    case SCHOOL_API_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case GET_ADDED_APPLICATION_PROGRAM: {
      const { application, saved_programs, application_programs } = action.payload;
      let saved_app_data = {};
      saved_app_data[application] = {
        'savedPrograms': saved_programs,
        'applicationPrograms': application_programs
      }
      state.studentAppData = saved_app_data;
      sync_saved_program_application_program(application, state, '');
      return {
        ...state,
      };
    }

    case GET_SR_ADDITIONAL_QUESTIONS_SUCCESS: {
      const { questions } = action.payload;
      state.srAdditionalQuestions = questions;
      return {
        ...state,
      };
    }

    case SYNC_ADDED_PROGRAM_SAVED_PROGRAM: {
      const { application, queryParams } = action.payload;
      if(state.studentAppData){
        sync_saved_program_application_program(application, state, queryParams);
      }
      return {
        ...state,
      };
    }

    default:
      return state;
  }
}
